<template>
  <el-container>
    <el-main style="padding: 0">
      <span>喷涂扫描</span>
      <el-divider/>
      <el-form
          ref="form"
          style="width: 500px"
          :model="model"
          class="form"
          label-width="90px">
        <el-form-item label="工作中心">
          <el-input v-model="model.workCenterName" readonly placeholder="请选择工作中心">
            <el-button slot="append" @click="$refs.selectWorkCenter.open()">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="间隔时间(S)">
          <el-input v-model.trim="model.delayTime" placeholder="请输入间隔时间(大于0的整数)" @input="delayTimeInput"/>
        </el-form-item>
        <el-form-item label="链位号">
          <el-input ref="secondInput" v-model.trim="model.chainTagNo" placeholder="请扫描链位号" @keyup.enter.native="chainTagNoScan"/>
        </el-form-item>
        <el-form-item label="物料序列号">
          <el-input
              ref="thirdInput"
              v-model.trim="model.materialSn"
              :disabled="disabled"
              placeholder="请扫描物料序列号"
              @keyup.enter.native="sprayScan"/>
        </el-form-item>
      </el-form>
      <span>喷涂记录</span>
      <el-divider/>
      <vm-table
          ref="vmTable"
          :is-height="false"
          :columns-btn-show="false"
          module="basic"
          url="materialSnChainTagNoes">
        <el-table-column prop="workCenterName" min-width="140" align="center" label="工单中心"/>
        <el-table-column width="100" align="center" label="间隔时间(S)">
          <template slot-scope="scope">
            <span>{{($moment(scope.row.startPrintTime).valueOf() - $moment(scope.row.createTime).valueOf()) / 1000}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="chainTagNo" min-width="140" align="center" label="链位号"/>
        <el-table-column prop="materialSn" min-width="160" align="center" label="物料序列号"/>
        <el-table-column prop="scanIndex" width="100" align="center" label="顺序"/>
        <el-table-column prop="statusName" width="100" align="center" label="状态"/>
        <el-table-column prop="creatorName" width="100" align="center" label="创建人"/>
        <el-table-column prop="createTime" width="140" align="center" label="创建时间"/>
        <el-table-column prop="snPrintTimes" width="100" align="center" label="打印次数"/>
        <el-table-column prop="startPrintTime" width="140" align="center" label="开始打印时间"/>
      </vm-table>
    </el-main>
    <work-center-select ref="selectWorkCenter" @select="onSelectWorkCenter"/>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  export default {
    name: "SprayScan",
    components: {
      VmTable,
      WorkCenterSelect,
    },

    data() {
      return {
        model: {
          workCenterName: "",
          delayTime: "",
          chainTagNo: "",
          materialSn: "",
          workCenterId: "",
        },
      };
    },

    computed: {
      disabled() {
        if (this.model.workCenterName && this.model.delayTime && this.model.chainTagNo) {
          return false;
        } else {
          return true;
        }
      },
    },

    mounted() {
      this.$refs.vmTable.getList(1);
    },

    methods: {
      // 工作中心选择
      onSelectWorkCenter(row) {
        this.model.workCenterId = row.pkId;
        this.model.workCenterName = row.workCenterName;
        if (this.model.workCenterName && this.model.delayTime && this.model.chainTagNo) {
          this.disabled = false;
        }
      },

      // 喷涂扫描
      sprayScan() {
        this.$http.post("basic", "materialSnChainTagNoes", this.model).then((resp) => {
          if (resp.success) {
            this.$message.success("扫描成功");
            this.model.chainTagNo = "";
            this.model.materialSn = "";
            this.$refs.secondInput.focus();
            this.$refs.vmTable.getList(1);
          }
        });
      },

      // 链位号扫描
      chainTagNoScan() {
        if (this.model.workCenterName && this.model.delayTime && this.model.chainTagNo) {
          this.$refs.thirdInput.focus();
        }
      },

      // 间隔时间必须为正整数
      delayTimeInput(value) {
        const reg = /^[1-9]\d*$/;
        if (!reg.test(value)) {
          this.$confirm("请输入大于0的整数", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.model.delayTime = "";
        }
      },
    },
  };
</script>
